import OptimizedImage from "@/components/OptimizedImage";

interface ExpertCardProps {
  image: string;
  name: string;
  title: string;
  quote: string;
  imageScale?: number;
}

const ExpertCard = ({ image, name, title, quote, imageScale = 1 }: ExpertCardProps) => {
  return (
    <div className="text-center">
      <div className="w-32 h-32 rounded-full mx-auto mb-6 overflow-hidden shadow-md">
        <OptimizedImage
          className="w-full h-full object-cover" 
          style={{ transform: `scale(${imageScale})` }}
          src={image}
          alt={`Portrait ${name}`}
          priority={false}
        />
      </div>
      <h3 className="text-foreground mb-2">{name}</h3>
      <p className="text-primary font-medium mb-4">{title}</p>
      <p className="text-muted-foreground italic">"{quote}"</p>
    </div>
  );
};

export default ExpertCard;
